import { render, staticRenderFns } from "./StoryChangelog.vue?vue&type=template&id=5010d95e&scoped=true"
import script from "./StoryChangelog.vue?vue&type=script&lang=js"
export * from "./StoryChangelog.vue?vue&type=script&lang=js"
import style0 from "./StoryChangelog.vue?vue&type=style&index=0&id=5010d95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010d95e",
  null
  
)

export default component.exports